import { CancelConditionSchedule } from "../objects/cancelCondition";
import { CancelConditionFormType } from "../objects/cancelConditionForm";
import { CancelConditionListConfiguration, CancelConditionListCriteria, CancelConditionListFiltersCriteria } from "../objects/cancelConditionList";
import { Column } from "../objects/column";

export const EMPTY_CANCEL_CONDITION_SCHEDULE: CancelConditionSchedule = {
    percentage: null,
    from_day: null,
    to_day: null
};

export const EMPTY_CANCEL_CONDITION_FORM: CancelConditionFormType = {
    name_locales: {},
    introduction_text_locales: {},
    main_text_locales: {},
    bottom_text_locales: {},
    is_apps: true,
    is_cms: true,
    use_provider_amount_when_higher: false,
    minimum_amount_per_pax: null,
    full_fee_product_types: [],
    schedule: []
};

export const DEFAULT_CANCEL_CONDITION_COLUMNS: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'is-apps',
    field_name: 'IS_APPS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'is-cms',
    field_name: 'IS_CMS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false
}];

export const EMPTY_CANCEL_CONDITION_FILTERS: CancelConditionListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION"
};

export const EMPTY_CANCEL_CONDITION_LIST_CRITERIA: CancelConditionListCriteria = {
    search: '',
    page: 0,
    limit: 50,
    order: 'asc',
    order_by: '',
    filters: EMPTY_CANCEL_CONDITION_FILTERS
};

export const EMPTY_CANCEL_CONDITION_LIST_CONFIGURATION: CancelConditionListConfiguration = {
    columns: DEFAULT_CANCEL_CONDITION_COLUMNS,
    preferences: []
};

export const CANCEL_CONDITION_MODULE = 'CANCEL_CONDITION';

export const CANCEL_CONDITION_FULL_FEE_PRODUCT_TYPES: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 18, 19];
